//20250602 axa inici
import { BasketProduct } from "./basket";
import { FileProduct, Product } from "./product";
//20250602 axa final

export class PickUpCenter {
    centerid: string = '';
    centername: string = '';
    addressing : string  = ''; 
    mapURL : any;
    TipoRecogida: string = '';
}

export class SubstPolicy {
    codi: number;
    text: string;
    idioma : string   ;
}

export class  PlusiCard {
    birth_plusi_card: string
    phone_plusi_card: string
    id_plusi_card: string
    punts: string
}

export class  UnitMeasure {
    idioma : string
    codi : string
    text : string
}


//20250602 axa inici
// export class AxABasketError{
//   message : string
//   product :  FileProduct
// }
export class AxABasketError extends BasketProduct {
  conflict_message: string;

  constructor(values: Object = {}) {
    super(values);
  }

}

//20250602 axa final
